import useMountEffect from '@restart/hooks/useMountEffect';
import classNames from 'classnames/bind';
import dayjs from 'dayjs';
import React, { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FieldNumber } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const domRefs = useRef({
    hold: useRef(),
    hour: useRef(),
    minute: useRef(),
    second: useRef(),
    time: useRef(),
  }).current;

  useEffect(() => {
    domRefs.hold.current.value = command.data.hold;
    domRefs.hour.current.value = command.data.hour;
    domRefs.minute.current.value = command.data.minute;
    domRefs.second.current.value = command.data.second;
  }, [command.data]);

  useMountEffect(() => {
    const updateUTCTime = () => {
      domRefs.time.current.innerText = dayjs().utc().format('HH:mm:ss');
    };

    updateUTCTime();
    const intervalId = setInterval(updateUTCTime, 1000);

    return () => {
      clearInterval(intervalId);
    };
  });

  const handleBlur = (e) => {
    const name = e.target.name;
    let value = Math.trunc(e.target.value);

    // https://mavlink.io/en/messages/common.html#MAV_CMD_NAV_DELAY
    switch (name) {
      case 'hold':
        value = Math.max(-1, value);
        break;
      case 'hour':
        value = Math.min(Math.max(-1, value), 23);
        break;
      case 'minute':
      case 'second':
        value = Math.min(Math.max(-1, value), 59);
        break;
      default:
        break;
    }

    dispatch(actions.mission.updateCommand(index, name, value));
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Hold" unit="secs">
        <FieldNumber ref={domRefs.hold} name="hold" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Hour (UTC)">
        <FieldNumber ref={domRefs.hour} name="hour" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Minute (UTC)">
        <FieldNumber ref={domRefs.minute} name="minute" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Second (UTC)">
        <FieldNumber ref={domRefs.second} name="second" onBlur={handleBlur} />
      </FieldRow>
      <div className={cx('message')}>
        The current time in UTC is <span ref={domRefs.time} />
      </div>
    </div>
  );
};

export default Command;
